<app-guest>
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <h2 class="fw-bold fs-5 text-center mb-3">Create an Account</h2>
    <div class="mb-3">
      <div class="input-group">
        <span class="input-group-text"><i class="bi bi-building"></i></span>
        <input type="text" class="form-control" id="company-name" placeholder="Company Name"
          formControlName="companyName">
      </div>
      <app-form-error [formError]="formError" formFieldName="companyName"></app-form-error>
    </div>
    <div class="mb-3">
      <div class="input-group">
        <span class="input-group-text"><i class="bi bi-person"></i></span>
        <input type="text" class="form-control" id="firstname" placeholder="Firstname" formControlName="firstname">
      </div>
      <app-form-error [formError]="formError" formFieldName="firstname"></app-form-error>
    </div>
    <div class="mb-3">
      <div class="input-group">
        <span class="input-group-text"><i class="bi bi-person"></i></span>
        <input type="text" class="form-control" id="lastname" placeholder="Lastname" formControlName="lastname">
      </div>
      <app-form-error [formError]="formError" formFieldName="lastname"></app-form-error>
    </div>
    <div class="mb-3">
      <div class="input-group">
        <span class="input-group-text"><i class="bi bi-geo-alt"></i></span>
        <input type="text" class="form-control" id="address" placeholder="Address" formControlName="address">
      </div>
      <app-form-error [formError]="formError" formFieldName="address"></app-form-error>
    </div>
    <div class="row">
      <div class="col-md-6 mb-3">
        <div class="input-group">
          <span class="input-group-text"><i class="bi bi-signpost"></i></span>
          <input type="text" class="form-control" id="zip-code" placeholder="Zip Code" formControlName="zipCode">
        </div>
        <app-form-error [formError]="formError" formFieldName="zipCode"></app-form-error>
      </div>
      <div class="col-md-6 mb-3">
        <div class="input-group">
          <span class="input-group-text"><i class="bi bi-buildings"></i></span>
          <input type="text" class="form-control" id="city" placeholder="City" formControlName="city">
        </div>
        <app-form-error [formError]="formError" formFieldName="city"></app-form-error>
      </div>
    </div>
    <div class="mb-3">
      <div class="input-group">
        <span class="input-group-text"><i class="bi bi-map"></i></span>
        <input type="text" class="form-control" id="state" placeholder="State" formControlName="state">
      </div>
      <app-form-error [formError]="formError" formFieldName="state"></app-form-error>
    </div>
    <div class="mb-3">
      <div class="input-group">
        <span class="input-group-text"><i class="bi bi-globe"></i></span>
        <app-dropdown-select formControlName="country" placeholder="Country">
          @for (country of countries; track country) {
            <app-dropdown-select-option [value]="country.isoCode">
              {{ country }}
            </app-dropdown-select-option>
          }
        </app-dropdown-select>
      </div>
      <app-form-error [formError]="formError" formFieldName="country"></app-form-error>
    </div>
    <div class="mb-3">
      <div class="input-group">
        <span class="input-group-text"><i class="bi bi-envelope"></i></span>
        <input type="email" class="form-control" id="email-register" placeholder="Email Address"
          formControlName="email">
      </div>
      <app-form-error [formError]="formError" formFieldName="email"></app-form-error>
    </div>
    <div class="mb-3">
      <div class="input-group">
        <span class="input-group-text"><i class="bi bi-telephone"></i></span>
        <input type="tel" class="form-control" id="phone-number" placeholder="Phone Number"
          formControlName="phoneNumber">
      </div>
      <app-form-error [formError]="formError" formFieldName="phoneNumber"></app-form-error>
    </div>
    <div class="mb-3">
      <div class="input-group">
        <span class="input-group-text"><i class="bi bi-translate"></i></span>
        <app-dropdown-select [multiple]="true" formControlName="langs" placeholder="Language">
          @for (lang of getLangs(); track lang) {
            <app-dropdown-select-option [value]="lang.id">
              <img [ngSrc]="langService.getFlag(lang)" [alt]="lang.name" width="24" height="24"
                class="me-1 country-flag">{{ lang.name }}
              </app-dropdown-select-option>
            }
          </app-dropdown-select>
        </div>
        <app-form-error [formError]="formError" formFieldName="langs"></app-form-error>
      </div>
      <div class="mb-3">
        <div class="input-group">
          <span class="input-group-text"><i class="bi bi-telegram"></i></span>
          <input type="text" class="form-control" id="telegram" placeholder="Telegram Username"
            formControlName="telegram">
        </div>
        <app-form-error [formError]="formError" formFieldName="telegram"></app-form-error>
      </div>
      <div class="mb-3">
        <div class="input-group">
          <span class="input-group-text"><i class="bi bi-microsoft-teams"></i></span>
          <input type="text" class="form-control" id="teams" placeholder="Teams Username" formControlName="teams">
        </div>
        <app-form-error [formError]="formError" formFieldName="teams"></app-form-error>
      </div>
      <h3 class="fs-6 fw-bold mt-3">To know a little more about you</h3>
      <div class="mb-3">
        <div class="input-group">
          <span class="input-group-text"><i class="bi bi-graph-up"></i></span>
          <app-dropdown-select [multiple]="true" formControlName="trafficSourceList" placeholder="Traffic Sources">
            @for (trafficSource of trafficSourceList; track trafficSource) {
              <app-dropdown-select-option
                [value]="trafficSource">{{ 'trafficSource.' + trafficSource | translate }}
              </app-dropdown-select-option>
            }
          </app-dropdown-select>
        </div>
        <app-form-error [formError]="formError" formFieldName="trafficSourceList"></app-form-error>
      </div>
      <div class="mb-3">
        <div class="input-group">
          <span class="input-group-text"><i class="bi bi-bar-chart"></i></span>
          <app-dropdown-select formControlName="typology" placeholder="Typology">
            @for (typology of typologyList; track typology) {
              <app-dropdown-select-option
                [value]="typology">{{ 'typology.' + typology | translate }}
              </app-dropdown-select-option>
            }
          </app-dropdown-select>
        </div>
        <app-form-error [formError]="formError" formFieldName="typology"></app-form-error>
      </div>
      <div class="mb-3">
        <div class="input-group">
          <span class="input-group-text"><i class="bi bi-award"></i></span>
          <app-dropdown-select formControlName="experience" placeholder="Experiency">
            @for (experience of experienceList; track experience) {
              <app-dropdown-select-option
                [value]="experience">{{ 'experience.' + experience | translate }}
              </app-dropdown-select-option>
            }
          </app-dropdown-select>
        </div>
        <app-form-error [formError]="formError" formFieldName="experience"></app-form-error>
      </div>
      <div class="mb-3">
        <div class="input-group">
          <span class="input-group-text"><i class="bi bi-tag"></i></span>
          <app-dropdown-select [multiple]="true" formControlName="verticals" placeholder="Verticals">
            @for (vertical of verticalList; track vertical) {
              <app-dropdown-select-option
                [value]="vertical.id">{{ ('vertical.' + vertical.identifier) | translate }}
              </app-dropdown-select-option>
            }
          </app-dropdown-select>
        </div>
        <app-form-error [formError]="formError" formFieldName="verticals"></app-form-error>
      </div>
      <div class="mb-3">
        <div class="input-group">
          <span class="input-group-text"><i class="bi bi-currency-dollar"></i></span>
          <app-dropdown-select formControlName="estimatedMonthlyRevenue" placeholder="Estimated monthly revenues">
            @for (estimatedMonthlyRevenue of estimatedMonthlyRevenueList; track estimatedMonthlyRevenue) {
              <app-dropdown-select-option
                [value]="estimatedMonthlyRevenue">{{ 'estimatedMonthlyRevenue.' + estimatedMonthlyRevenue | translate }}
              </app-dropdown-select-option>
            }
          </app-dropdown-select>
        </div>
        <app-form-error [formError]="formError" formFieldName="estimatedMonthlyRevenue"></app-form-error>
      </div>
      <div class="mb-3">
        <div class="input-group">
          <span class="input-group-text"><i class="bi bi-geo"></i></span>
          <app-dropdown-select [multiple]="true" formControlName="geographicAreaList" placeholder="Geos">
            @for (geographicArea of geographicAreaList; track geographicArea) {
              <app-dropdown-select-option
                [value]="geographicArea">{{ 'geographicArea.' + geographicArea | translate }}
              </app-dropdown-select-option>
            }
          </app-dropdown-select>
        </div>
        <app-form-error [formError]="formError" formFieldName="geographicAreaList"></app-form-error>
      </div>
      <div class="mb-3">
        <div class="input-group">
          <span class="input-group-text"><i class="bi bi-link"></i></span>
          <input type="url" class="form-control" id="website-url" placeholder="Website URL" formControlName="websiteUrl">
        </div>
        <app-form-error [formError]="formError" formFieldName="websiteUrl"></app-form-error>
      </div>
      <div class="d-grid mb-3">
        <button type="submit" class="btn btn-primary fw-bold p-lg-3">Sign Up</button>
      </div>
      <div class="text-center small">Already have an account? <a routerLink="/login">Sign in</a></div>
    </form>
  </app-guest>
